import { render } from "./LegacyReportHomeModal.vue?vue&type=template&id=04e6b43f"
import script from "./LegacyReportHomeModal.vue?vue&type=script&lang=js"
export * from "./LegacyReportHomeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__